import { Box } from "@mui/material";
import React from "react";
import useTheme from "../../../../../../../common/hooks/useTheme";
import { formatWeekdayShortDate } from "../../../../../../../common/utils/date";
import { Theme } from "../../../../../../../providers/ThemeProvider";
import { eventDisplayName } from "../../helpers/activitySelectors";
import { ActivityEvent } from "../../model/workoutPlanTypes";
import WearableDataSection from "./WearableDataSection";

type Props = {
  event: ActivityEvent;
  date: string;
};

/**
 * A wearable-recorded activity's details, after the mobile
 * `WorkoutDetailsScreen` for an unscheduled entry: the day and the name,
 * then the "Wearable Data" block with the recorded session. Everything comes
 * from the week; nothing is fetched.
 */
const TrackedActivityContent = ({ event, date }: Props) => {
  const theme: Theme = useTheme();

  return (
    <>
      <Box sx={styles.titleBlock}>
        <Box sx={styles.date(theme)}>{formatWeekdayShortDate(date)}</Box>
        <Box sx={styles.title(theme)}>{eventDisplayName(event)}</Box>
      </Box>
      <WearableDataSection events={[event]} />
    </>
  );
};

export default TrackedActivityContent;

const styles = {
  titleBlock: {
    display: "flex",
    flexDirection: "column" as "column",
    gap: "4px",
  },
  date: (theme: Theme) => ({
    color: theme.colors_ds.NEUTRAL_TEXT_WEAK,
    fontFamily: "var(--font-Regular)",
    fontSize: "14px",
    lineHeight: "20px",
  }),
  title: (theme: Theme) => ({
    color: theme.colors_ds.NEUTRAL_TEXT_STRONG,
    fontFamily: "var(--font-Bold)",
    fontSize: "20px",
    lineHeight: "28px",
  }),
};
